<script setup lang="ts">
defineProps<{
    company: any
}>()

const { state } = useAppStore()
</script>

<template>
    <section class="py-9 bg-chsc-raw-light border-t border-b border-chsc-raw-dark">
        <UContainer>
            <div class="flex items-start gap-20 max-[641px]:flex-col max-[641px]:gap-10">
                <div>
                    <h4 class="font-montserrat fs-xs font-bold uppercase">
                        {{ useText(state.strings, 'sc_headquarters') }}
                    </h4>
                    <p class="font-montserrat fs-sm">
                        <span v-if="company.headquarters">{{ company.headquarters }}</span>
                        <span v-else>-</span>
                    </p>
                </div>
                <div>
                    <h4 class="font-montserrat fs-xs font-bold uppercase">
                        {{ useText(state.strings, 'sc_product_lines') }}
                    </h4>
                    <p class="font-montserrat fs-sm">
                        <span v-if="company.product_lines">{{ company.product_lines }}</span>
                        <span v-else>-</span>
                    </p>
                </div>
                <div>
                    <h4 class="font-montserrat fs-xs font-bold uppercase">
                        {{ useText(state.strings, 'sc_type') }}
                    </h4>
                    <p class="font-montserrat fs-sm">
                        <span v-if="company.size_id">{{ useCompanySizeName(state.sizes, company.size_id) }}</span>
                        <span v-else>-</span>
                    </p>
                </div>
            </div>
        </UContainer>
    </section>
</template>
